import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = { class: "d-block" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "d-block" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "d-block" }
const _hoisted_9 = {
  role: "group",
  class: "input-group"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, " X: ", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, " Y: ", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  tabindex: "-1",
  class: "form-text text-muted"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop","prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.t('cropfilter.form.mode.label')), 1),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mode) = $event)),
          name: "mode",
          class: "mt-3 form-select form-select-sm"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modeList, (modeItem) => {
            return (_openBlock(), _createElementBlock("option", {
              key: modeItem.value,
              value: modeItem.value
            }, _toDisplayString(modeItem.text), 9, _hoisted_3))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.mode]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t('cropfilter.form.position.label')), 1),
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.position) = $event)),
          name: "position",
          class: "mt-3 form-select form-select-sm"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.positionList, (positionItem) => {
            return (_openBlock(), _createElementBlock("option", {
              key: positionItem.value,
              value: positionItem.value
            }, _toDisplayString(positionItem.text), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.position]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t('cropfilter.form.sizes.label')), 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("input", {
            type: "number",
            name: "width",
            placeholder: "auto",
            min: "0",
            step: "1",
            class: "form-control",
            value: _ctx.inputSizeFormatter(_ctx.width),
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.width = Number(($event.target as HTMLInputElement).value)))
          }, null, 40, _hoisted_11),
          _hoisted_12,
          _createElementVNode("input", {
            type: "number",
            name: "height",
            placeholder: "auto",
            min: "0",
            step: "1",
            class: "form-control",
            value: _ctx.inputSizeFormatter(_ctx.height),
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.height = Number(($event.target as HTMLInputElement).value)))
          }, null, 40, _hoisted_13)
        ]),
        _createElementVNode("small", _hoisted_14, _toDisplayString(_ctx.t('cropfilter.form.sizes.description')), 1)
      ])
    ])
  ], 32))
}